import { UserState } from './user.state'

export class UserUpdaters {
  static setUser(state: UserState, user: UserState['user']): UserState {
    return {
      ...state,
      user: user,
      isLoading: false,
      error: null,
    }
  }
  static setToken(state: UserState, token: UserState['token']): UserState {
    return {
      ...state,
      token,
      isLoading: false,
      error: null,
    }
  }

  static setRefreshToken(state: UserState, token: UserState['refreshToken']): UserState {
    return {
      ...state,
      refreshToken: token,
      isLoading: false,
      error: null,
    }
  }

  static setCsrfToken(state: UserState, token: UserState['csrfToken']): UserState {
    return {
      ...state,
      csrfToken: token,
    }
  }

  static setMfaChallenge(state: UserState, mfaToken: string): UserState {
    return {
      ...state,
      mfaToken,
      isLoading: false,
      error: null,
    }
  }

  static clearMfaChallenge(state: UserState): UserState {
    return {
      ...state,
      mfaToken: null,
      error: null,
    }
  }

  static setPasswordExpiredChallenge(state: UserState, email: string): UserState {
    return {
      ...state,
      passwordExpiredEmail: email,
      isLoading: false,
      error: null,
    }
  }

  static clearPasswordExpiredChallenge(state: UserState): UserState {
    return {
      ...state,
      passwordExpiredEmail: null,
      error: null,
    }
  }
}
